import React from "react";
import { createSelector } from "reselect";
import { getCampaignSkills, getUserCampaignPoints } from "@microdoing/shared/services/userCampaign/selectors";
import { getAllCoachRecommendSkills } from "@microdoing/shared/services/coaching/selectors";
import { AppState } from "../rootReducer";

export const getNextCategories = createSelector(
  getAllCoachRecommendSkills,
  getCampaignSkills,
  (coachSkills, campaignSkills) => {
    return [...coachSkills, ...campaignSkills];
  },
);

export const getOldTeamPoints = (state: AppState) => state.action.oldTeamPoints;

export const getOldUserPoints = (state: AppState) => state.action.oldUserPoints;

export const getCampaignUserProgress = createSelector(
  getOldUserPoints,
  getUserCampaignPoints, (oldUserPoints, currentPoints) => {
    return currentPoints - oldUserPoints;
  })

export const getComment = (state: AppState) => state.action.comment;

export const getIsFeedbackSharedState = (state: AppState) =>
  state.action.isShared;

export const getRating = (state: AppState) => state.action.rating;

export const getDonePercentage = (state: AppState) =>
  state.action.donePercentage;

export const getSeeActionAgain = (state: AppState) =>
  state.action.seeActionAgain;

export const getActionTitle = (state: AppState) => state.action.title;

export const getActionCategory = (state: AppState) => state.action.language;

export const getAnalysisType = (state: AppState) => state.action.analysisType || "video";